"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordIdForEvent = exports.getEventTarget = exports.forEach = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
exports.forEach = forEach;
function getEventTarget(event) {
    if (event.composed === true && (0, browser_rum_core_1.isNodeShadowHost)(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
exports.getEventTarget = getEventTarget;
var recordIds = new WeakMap();
var nextId = 1;
function getRecordIdForEvent(event) {
    if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
    }
    return recordIds.get(event);
}
exports.getRecordIdForEvent = getRecordIdForEvent;
//# sourceMappingURL=utils.js.map